import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useState } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { GridView, GridLineX, GridLineY } from './styles/focal-point-picker-style';
import { useUpdateEffect } from '../utils/hooks';
var _window = window,
    clearTimeout = _window.clearTimeout,
    setTimeout = _window.setTimeout;
export default function FocalPointPickerGrid(_ref) {
  var _ref$bounds = _ref.bounds,
      bounds = _ref$bounds === void 0 ? {} : _ref$bounds,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["bounds", "value"]);

  var animationProps = useRevealAnimation(value);
  var style = {
    width: bounds.width,
    height: bounds.height
  };
  return createElement(GridView, _extends({}, props, animationProps, {
    className: "components-focal-point-picker__grid",
    style: style
  }), createElement(GridLineX, {
    style: {
      top: '33%'
    }
  }), createElement(GridLineX, {
    style: {
      top: '66%'
    }
  }), createElement(GridLineY, {
    style: {
      left: '33%'
    }
  }), createElement(GridLineY, {
    style: {
      left: '66%'
    }
  }));
}
/**
 * Custom hook that renders the "flash" animation whenever the value changes.
 *
 * @param {string} value Value of (box) side.
 */

function useRevealAnimation(value) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  useUpdateEffect(function () {
    setIsActive(true);
    var timeout = setTimeout(function () {
      setIsActive(false);
    }, 600);
    return function () {
      return clearTimeout(timeout);
    };
  }, [value]);
  return {
    isActive: isActive
  };
}
//# sourceMappingURL=grid.js.map